import * as Msal from '@azure/msal-browser';

function getDomainHintQueryParameter() {
    // Get domain from get if exists
    let result = null;

    const items = location.search.substring(1).split('&');
    items.forEach((item) => {
        const tmp = item.split('=');
        if (tmp[0] === 'domain_hint') {
            result = decodeURIComponent(tmp[1]);
        }
    });
    return result !== null
        ? `&domain_hint=${result}`
        : '';
}

export default class AuthenticationService {
    constructor() {
        this.scopes = null;
        this.app = null;
        this.accountObj = null;
        this.tokenResponse = null;
    }

    init = (WebAppConfig, context) => {
        const redirectPath = context === 'mobile' ? 'mobile' : 'dashboard';
        const redirectUri = `${location.origin}/${redirectPath}`;
        const postLogoutRedirectUri = `${location.origin}/${redirectPath}`;
        const msalConfig = {
            auth: {
                tenant: WebAppConfig.ad.tenant,
                clientId: WebAppConfig.ad.clientId,
                redirectUri,
                cacheLocation: 'localStorage', // changed from SessionStorage
                extraQueryParameter: `nux=1${getDomainHintQueryParameter()}`,
                postLogoutRedirectUri
            },
            cache: {
                cacheLocation: 'localStorage', // changed from sessionStorage
                storeAuthStateInCookie: true    // recommended for broader compatibility
            }
        };
        this.scopes = WebAppConfig.ad.scopes;
        this.app = new Msal.PublicClientApplication(msalConfig);
        return this.login();
    };

    login = async () => {
        try {
            this.tokenResponse = await this.app.handleRedirectPromise();
            if (this.tokenResponse) {
                this.accountObj = this.tokenResponse.account;
            } else {
                this.accountObj = this.app.getAllAccounts()[0];
            }
            if (this.accountObj && this.tokenResponse) {
                return;
            } else if (this.accountObj) {
                await this.refresh();
            } else {
                await this.app.loginRedirect({ scopes: this.scopes });
            }
        } catch (error) {
            console.error(
                '[AuthService.init] Failed to handleRedirectPromise()',
                error
            );
        }
    };

    refresh = async () => {
        try {
            this.tokenResponse = await this.app.acquireTokenSilent({
                account: this.app.getAllAccounts()[0],
                scopes: this.scopes
            });
        } catch (err) {
            await this.app.acquireTokenRedirect({ scopes: this.scopes });
        }
    };

    logout() {
        this.app.logout();
    }
}
